import React from 'react'
import "./apply.css"

function head() {
  return (
    <div className='apply-head'></div>
  )
}

export default head